"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { EnabledUnitsProps } from "./EnabledUnitsChart.impl";

export const EnabledUnitsChart = dynamicChart(
  () => import("./EnabledUnitsChart.impl").then((m) => m.EnabledUnitsChart),
  340,
);
